import { RouterProvider } from "react-router-dom";
import { router } from "@/router";
import Toasts from "@/components/Toasts";
import SessionExpiredModal from "@/components/modals/SessionExpiredModal";

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toasts />
      <SessionExpiredModal />
    </>
  );
}
